// extracted by mini-css-extract-plugin
export default {"container":"list_container__xnUnJ","progress":"list_progress__j94dn","progress_text":"list_progress_text__QaP5I","progress_protsent":"list_progress_protsent__Z6tdF"};